'use client'

import type { ColorPreviewsProps } from '@maestro/commerce-blocks/components/color-previews/color-previews.types'

import { useTranslations } from 'next-intl'

import { useColorPreviews } from '@maestro/commerce-blocks/components/color-previews/batons/use-color-previews'

export default function ColorPreviews({ product }: ColorPreviewsProps) {
  const { uniqueColors, colorPreviewMapping } = useColorPreviews(product)
  const t = useTranslations('commerce-blocks')

  if (uniqueColors.length < 2) {
    return null
  }

  return (
    <ul
      className="product-configuration__color"
      aria-label={t('color-previews.available-colors')}
    >
      {uniqueColors.map((color) => (
        <li
          className="product-configuration__color-item"
          key={color}
          aria-label={colorPreviewMapping[color]?.name || color}
          style={
            {
              '--product-configuration__color':
                colorPreviewMapping[color]?.value ||
                colorPreviewMapping.fallback.value,
            } as React.CSSProperties & Record<string, string>
          }
        />
      ))}
    </ul>
  )
}
